// Admin endpoints — Packet W2a. Thin wrappers around `adminApi` (the
// shared axios instance with `withCredentials: true` for the sf_admin
// httpOnly cookie). No behavior change.
import { adminApi } from "../adminApi";

// --- Session ---------------------------------------------------------------
export const adminLogin = async (email, password) =>
  (await adminApi.post("/admin/login", { email, password })).data;

export const adminLogout = async () =>
  (await adminApi.post("/admin/logout")).data;

export const getAdminMe = async () => (await adminApi.get("/admin/me")).data;

// --- Read endpoints --------------------------------------------------------
export const getAdminOverview = async () =>
  (await adminApi.get("/admin/overview")).data;

export const listAdminAudits = async (params = {}) =>
  (await adminApi.get("/admin/audits", { params })).data;

export const getAdminAudit = async (sessionId) =>
  (await adminApi.get(`/admin/audits/${sessionId}`)).data;

export const getAdminEnv = async () =>
  (await adminApi.get("/admin/env")).data;

export const listAdminPayments = async (params = {}) =>
  (await adminApi.get("/admin/payments", { params })).data;

export const listAdminImplementationRequests = async (params = {}) =>
  (await adminApi.get("/admin/implementation-requests", { params })).data;

// --- Write endpoints -------------------------------------------------------
export const simulateAdminPayment = async (sessionId) =>
  (await adminApi.post(`/admin/audits/${sessionId}/simulate-payment`)).data;

export const patchImplementationRequest = async (requestId, body) =>
  (await adminApi.patch(`/admin/implementation-requests/${requestId}`, body)).data;

// --- Consultations (admin) ------------------------------------------------
// Packet 4.5C — surfaces the live P4.5A backend endpoints.
export const listAdminConsultations = async (params = {}) =>
  (await adminApi.get("/admin/consultations", { params })).data;

export const patchConsultation = async (consultationId, body) =>
  (await adminApi.patch(`/admin/consultations/${consultationId}`, body)).data;
